export { default } from './CoreMap';
